import { Box, Menu, MenuItem, Button, styled } from "@mui/material";
import React, { useState } from "react";
import {  useLocation } from "react-router-dom";
import { Menu as MenuIcon } from "lucide-react";
import { HashLink as LinkTo } from "react-router-hash-link"; 

const NavBar = () => {
  const [burgerEL, setBurgerEL] = useState(null);
  const location = useLocation();

  const handleClickBurger = (event) => {
    setBurgerEL(event.currentTarget);
  };

  const handleCloseBurger = () => {
    setBurgerEL(null);
  };

  const StyledLink = styled(LinkTo)(({ theme, to }) => ({
    textDecoration: "none",
    color: location.pathname === to ? "#FF0000" : "black", // اللون الأحمر للنشط والأزرق للعادي
    fontFamily: "Arial, sans-serif",
    fontSize: "1rem",
    fontWeight: 500,
    margin: "0 10px",
    transition: "color 0.3s",
    "&:hover": {
      color: "#CCCCCC", // الرمادي عند التمرير
    },
    "&:after": {
      content: '""',
      display: "block",
      width: "0",
      height: "2px",
      backgroundColor: "#FF0000", // خط سفلي بالأحمر
      transition: "width 0.3s ease-in-out",
    },
    "&:hover:after": {
      width: "100%",
    },
  }));

  return (
    <nav
      style={{
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 1000,
        background: "linear-gradient(to right, #ece9e6, #ffffff)",

        // backgroundColor: "rgba(255, 255, 255, 0.95)", // خلفية بيضاء شفافة
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.1)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        padding: "10px",
      }}
    >
      <Box
      sx={{
        marginLeft:'30px'
      }}
      >
        <img
          src="/ElektrotechnikEMN.png"
          alt="ElektrotechnikEMN"
          style={{
            width: "150px",
            height: "70px",
            objectFit: "cover",
            
          }}
        />
      </Box>
      <Box
        px={2}
        py={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        <Box
          display={{ md: "flex", xs: "none" }}
          alignItems="center"
        >
          <StyledLink to="/" onClick={() => { window.scrollTo(0, 0); }}>Startseite</StyledLink>
          <StyledLink to="/#about">Über uns</StyledLink>
          <StyledLink to="/#services">Dienstleistungen</StyledLink>
          <StyledLink to="/#contact">Kontaktieren Sie uns</StyledLink>
          <StyledLink to="/appointment" onClick={() => { window.scrollTo(0, 0); }}>Termin buchen</StyledLink>
          <StyledLink to="/arbeiten"  onClick={() => { window.scrollTo(0, 0); }}>Unsere Arbeiten</StyledLink>

        </Box>

        {/* Burger Menu */}
        <Box display={{ md: "none", xs: "block" }}>
          <Button
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClickBurger}
            sx={{ minWidth: "auto", padding: 0 }}
          >
            <MenuIcon size={24} style={{ color: "#007BFF" }} /> {/* لون الأيقونة أزرق */}
          </Button>
          <Menu
            id="simple-menu"
            anchorEl={burgerEL}
            open={Boolean(burgerEL)}
            onClose={handleCloseBurger}
            sx={{
              "& .MuiPaper-root": {
                backgroundColor: "#FFFFFF", // خلفية بيضاء للقائمة
                color: "black", // نص أسود
                borderRadius: "8px",
                boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
              },
            }}
          >
            <MenuItem onClick={handleCloseBurger}>
              <StyledLink to="/" onClick={() => { window.scrollTo(0, 0); }}>Startseite</StyledLink>
            </MenuItem>
            <MenuItem onClick={handleCloseBurger}>
              <StyledLink to="/#about">Über uns</StyledLink>
            </MenuItem>
            <MenuItem onClick={handleCloseBurger}>
              <StyledLink to="/#services">Dienstleistungen</StyledLink>
            </MenuItem>
            <MenuItem onClick={handleCloseBurger}>
              <StyledLink to="/#contact">Kontaktieren Sie uns</StyledLink>
            </MenuItem>
            <MenuItem onClick={handleCloseBurger}>
              <StyledLink to="/appointment" onClick={() => { window.scrollTo(0, 0); }}>Termin buchen</StyledLink>
            </MenuItem>
            <MenuItem onClick={handleCloseBurger}>
            <StyledLink to="/arbeiten" onClick={() => { window.scrollTo(0, 0); }}>Unsere Arbeiten</StyledLink>

            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </nav>
  );
};

export default NavBar;